import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseUrl from "../Config";

function CandidateRegistrationForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // Get ID from URL
  const excessToastShown = useRef(false);
  const { action } = location.state || {};

  const [formFields, setFormFields] = useState({
    candidateFirstName: "",
    candidateLastName: "",
    dateOfBirth: "",
    gender: "",
    officialEmail: "",
    whatsappNo: "",
    phoneNo: "",
    passportNumber: "",
    passportIssueDate: "",
    passportExpiryDate: "",
    professionalCategory: "",
    educationCategory: "",
    licenseCategory: "",
    totalProcessingFees: "",
    firstInstallmentPaid: "",
    secondInstallmentPaid: "",
    thirdInstallmentPaid: "",
    fourthInstallmentPaid: "",
    firstInstallmentDate: "",
    secondInstallmentDate: "",
    thirdInstallmentDate: "",
    fourthInstallmentDate: "",
    balance: "",
    licenseProcessedBy: "",
    registrationNumber: "",
    attachments: [],
    remarks: "",
    referredBy: "",
    profileImage: null,
    status: "",
    _id: null,
  });
  console.log("formFields////", formFields);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeSection, setActiveSection] = useState("personal");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [educationOptions, setEducationOptions] = useState([]);
  const [newEducation, setNewEducation] = useState("");
  const [professionalOptions, setProfessionalOptions] = useState([]);
  const [newProfessional, setNewProfessional] = useState("");
  const [currentDropdown, setCurrentDropdown] = useState(null); // 'education' or 'license'
  const [newLicense, setNewLicense] = useState("");
  const [licenseOptions, setLicenseOptions] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [lastRegNumber, setLastRegNumber] = useState("");
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoadingCandidate, setIsLoadingCandidate] = useState(false);

  // Status groups and options
  const statusGroups = {
    "online class": ["paid fees", "class going on", "finished"],
    dataflow: ["waiting for review application", "dataflow on process", "completed / discrepancy"],
    "exam booking": ["waiting for booking", "exam booked"],
    others: ["credential applied", "eligibility letter applied", "evaluation applied", "payment MD response" ],
    "final step": ["exam pass - successfully completed", "discontinued", "exam fail"],
  };

  // UI state for custom status dropdown
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const statusDropdownRef = useRef(null);

  console.log("formFields@@@@@@", formFields);
  console.log("educationOptions@@@@@@", educationOptions);

  const nameRegex = /^[a-zA-Z][a-zA-Z\s]*$/;
  const emailRegex = /^[a-z0-9]+([._-]?[a-z0-9]+)*@[a-z0-9-]+(\.(com|org|net|in))$/i;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Check if we're in edit mode
  useEffect(() => {
    if (id) {
      setIsEditing(true);
      // If opened with ID in URL but no candidate in state, fetch from API
      if (!location.state?.candidate) {
        fetchCandidate(id);
      }
    }
  }, [id, location.state]);

  // When status changes, update the selected group
  useEffect(() => {
    if (formFields.status) {
      const group = Object.keys(statusGroups).find((g) =>
        statusGroups[g].includes(formFields.status)
      );
      if (group) setSelectedGroup(group);
    }
  }, [formFields.status]);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target)
      ) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch candidate by ID
  const fetchCandidate = async (candidateId) => {
    setIsLoadingCandidate(true);
    try {
      const response = await axios.get(`${baseUrl}/candidate/${candidateId}`);
      const candidate = response.data;
      console.log("Fetched candidate from API:", candidate);
      populateForm(candidate);
    } catch (error) {
      console.error("Error fetching candidate:", error);
      toast.error("Failed to load candidate data");
    } finally {
      setIsLoadingCandidate(false);
    }
  };

  // Populate form with candidate data
  const populateForm = (candidate) => {
    const formatDateForInput = (dateString) => {
      if (!dateString || dateString === "0000-00-00") return "";

      // Create date in Indian timezone (UTC+5:30)
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn(`Invalid date: ${dateString}`);
        return "";
      }

      // Convert to local date in YYYY-MM-DD format (Indian timezone)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const existingAttachments = candidate.attachments || [];

    setFormFields({
      candidateFirstName: candidate.candidateFirstName || candidate.candidate_first_name || "",
      candidateLastName: candidate.candidateLastName || candidate.candidate_last_name || "",
      dateOfBirth: formatDateForInput(candidate.dateOfBirth || candidate.date_of_birth),
      gender: candidate.gender || "",
      officialEmail: candidate.officialEmail || candidate.official_email || "",
      whatsappNo: candidate.whatsappNo || candidate.whatsapp_no || "",
      phoneNo: candidate.phoneNo || candidate.phone_no || "",
      passportNumber: candidate.passportNumber || candidate.passport_number || "",
      passportIssueDate: formatDateForInput(candidate.passportIssueDate || candidate.passport_issue_date),
      passportExpiryDate: formatDateForInput(candidate.passportExpiryDate || candidate.passport_expiry_date),
      professionalCategory: candidate.professionalCategory || candidate.professional_category || "",
      educationCategory: candidate.educationCategory || candidate.education_category || "",
      licenseCategory: candidate.licenseCategory || candidate.license_category || "",
      totalProcessingFees: candidate.totalProcessingFees || candidate.total_processing_fees || "",
      firstInstallmentPaid: candidate.firstInstallmentPaid || candidate.first_installment_paid || "",
      secondInstallmentPaid: candidate.secondInstallmentPaid || candidate.second_installment_paid || "",
      thirdInstallmentPaid: candidate.thirdInstallmentPaid || candidate.third_installment_paid || "",
      fourthInstallmentPaid: candidate.fourthInstallmentPaid || candidate.fourth_installment_paid || "",
      firstInstallmentDate: formatDateForInput(candidate.firstInstallmentDate || candidate.first_installment_date),
      secondInstallmentDate: formatDateForInput(candidate.secondInstallmentDate || candidate.second_installment_date),
      thirdInstallmentDate: formatDateForInput(candidate.thirdInstallmentDate || candidate.third_installment_date),
      fourthInstallmentDate: formatDateForInput(candidate.fourthInstallmentDate || candidate.fourth_installment_date),
      balance: candidate.balance || "",
      licenseProcessedBy: candidate.licenseProcessedBy || candidate.license_processed_by || "",
      registrationNumber: candidate.registrationNumber || candidate.registration_number || "",
      attachments: existingAttachments,
      remarks: candidate.remarks || "",
      referredBy: candidate.referredBy || candidate.referred_by || "",
      profileImage: candidate.profileImage || candidate.profile_image,
      status: candidate.status || "",
      _id: candidate.id || candidate._id || id,
    });

    // If profile image exists, store the URL for display
    if (candidate.profileImage || candidate.profile_image) {
      // This will be handled in the render section
    }
  };

  // Original useEffect for location.state (for backward compatibility)
  useEffect(() => {
    if (location.state?.candidate) {
      const candidate = location.state.candidate;
      console.log("Editing candidate from state:", candidate);
      populateForm(candidate);
    }
  }, [location.state]);

  const processedByOptions = admins.map((admin) => admin.fullname);

  const fetchAdmins = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${baseUrl}/users`);
      console.log("Admin users fetched:", response.data);
      setAdmins(response.data);
    } catch (err) {
      setError("Failed to fetch admin users. Please try again.");
      console.error("Error fetching admins:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchEducationOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/education-categories`);
      const data = await response.json();
      console.log("data@@@@@@ed1111", data);

      setEducationOptions(data.map((item) => item.education_category));
    } catch (error) {
      console.error("Error fetching education options:", error);
    }
  };

  const fetchProfessionalOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/professional-categories`);
      const data = await response.json();
      console.log("data@@@@@@", data);
      setProfessionalOptions(data.map((item) => item.professional_category));
    } catch (error) {
      console.error("Error fetching professional categories:", error);
    }
  };

  useEffect(() => {
    fetchEducationOptions();
    fetchProfessionalOptions();
  }, []);

  const fetchLicenseOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/license-categories`);
      if (response.ok) {
        const data = await response.json();
        const categories = data.map((item) => item.license_category);
        setLicenseOptions(categories);
      }
    } catch (error) {
      console.error("Error fetching license options:", error);
    }
  };

  useEffect(() => {
    fetchLicenseOptions();
  }, []);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await axios.get(`${baseUrl}/candidates`);
        const data = response.data;
        console.log("Fetched candidates:", data);
        setCandidates(data);

        // Only auto-generate registration number for NEW candidates (not editing)
        if (!isEditing && !location.state?.candidate) {
          if (data && data.length > 0) {
            const sorted = data.sort((a, b) => {
              const numA = parseInt(a.registration_number?.split("-").pop() || 0);
              const numB = parseInt(b.registration_number?.split("-").pop() || 0);
              return numB - numA;
            });
            const lastReg = sorted[0]?.registration_number;
            const nextReg = generateNextRegistrationNumber(lastReg);
            setFormFields((prev) => ({ ...prev, registrationNumber: nextReg }));
          } else {
            setFormFields((prev) => ({ ...prev, registrationNumber: "ELX-AA-00-0001" }));
          }
        }
      } catch (err) {
        console.error("Error fetching candidates:", err);
      }
    };

    fetchCandidates();
  }, [isEditing]);

  function generateNextRegistrationNumber(current) {
    if (!current) return "ELX-AA-00-0001";

    const parts = current.split("-");
    if (parts.length !== 4) return "ELX-AA-00-0001";

    const prefix = parts.slice(0, 3).join("-") + "-";
    const num = parseInt(parts[3]);
    const nextNum = (num + 1).toString().padStart(4, "0");
    return `${prefix}${nextNum}`;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Field changed: ${name} = ${value}`);

    setFormFields((prev) => {
      const updatedFields = { ...prev, [name]: value };

      if (name === "candidateFirstName" || name === "candidateLastName") {
        if (!nameRegex.test(value) && value !== "") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Name should only contain letters",
          }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        }
      }

      if (name === "officialEmail") {
        if (!emailRegex.test(value) && value !== "") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Invalid email format",
          }));
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        }
      }

      if (
        name === "firstInstallmentPaid" ||
        name === "secondInstallmentPaid" ||
        name === "thirdInstallmentPaid" ||
        name === "fourthInstallmentPaid" ||
        name === "totalProcessingFees"
      ) {
        const total =
          name === "totalProcessingFees"
            ? parseFloat(value) || 0
            : parseFloat(prev.totalProcessingFees) || 0;
        const first =
          name === "firstInstallmentPaid"
            ? parseFloat(value) || 0
            : parseFloat(prev.firstInstallmentPaid) || 0;
        const second =
          name === "secondInstallmentPaid"
            ? parseFloat(value) || 0
            : parseFloat(prev.secondInstallmentPaid) || 0;
        const third =
          name === "thirdInstallmentPaid"
            ? parseFloat(value) || 0
            : parseFloat(prev.thirdInstallmentPaid) || 0;
        const fourth =
          name === "fourthInstallmentPaid"
            ? parseFloat(value) || 0
            : parseFloat(prev.fourthInstallmentPaid) || 0;

        const paid = first + second + third + fourth;

        const calculatedBalance = total - paid;

        updatedFields.balance = calculatedBalance >= 0 ? calculatedBalance.toFixed(2) : "0.00";

        if (paid > total) {
          if (!excessToastShown.current) {
            const excessAmount = (paid - total).toFixed(2);
            toast.warning(
              `Installment total (₹${paid.toLocaleString(
                "en-IN"
              )}) exceeds the total fees (₹${total.toLocaleString(
                "en-IN"
              )}) by ₹${excessAmount}. ` +
                `Please adjust the installment amounts or increase the total processing fees.`,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                onClose: () => {
                  excessToastShown.current = false;
                },
              }
            );
            excessToastShown.current = true;
          }
        } else {
          excessToastShown.current = false;
        }
      }

      return updatedFields;
    });
  };

  const handlePhoneChange = (value, field) => {
    // Remove hyphens from the phone number
    const cleanedValue = value ? value.replace(/-/g, "") : "";
    // Continue with your existing logic
    setFormFields((prev) => ({ ...prev, [field]: cleanedValue }));
  };

  const handleFileSelect = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles.length === 0) return;

    const currentAttachments = formFields.attachments || [];
    const totalFilesAfterAddition = currentAttachments.length + newFiles.length;
    if (totalFilesAfterAddition > 10) {
      alert(
        `You can only upload up to 10 files. You currently have ${currentAttachments.length} and tried to add ${newFiles.length} more.`
      );
      e.target.value = "";
      return;
    }

    const validFiles = [];
    const invalidFiles = [];

    newFiles.forEach((file) => {
      if (file.size > 10 * 1024 * 1024) {
        invalidFiles.push({ file, reason: "File size exceeds 10MB" });
        return;
      }

      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        invalidFiles.push({ file, reason: "Unsupported file type (only PNG, JPG, JPEG, or PDF allowed)" });
        return;
      }

      validFiles.push(file);
    });

    if (invalidFiles.length > 0) {
      alert(
        `The following files were not added:\n${invalidFiles
          .map((f) => `${f.file.name} - ${f.reason}`)
          .join("\n")}`
      );
    }

    if (validFiles.length > 0) {
      setFormFields((prev) => ({
        ...prev,
        attachments: [...(prev.attachments || []), ...validFiles],
      }));
    }

    e.target.value = "";
  };

  const removeAttachment = (index) => {
    setFormFields((prev) => {
      const newAttachments = [...prev.attachments];
      newAttachments.splice(index, 1);
      return {
        ...prev,
        attachments: newAttachments,
      };
    });
  };

  const handleAddEducation = async () => {
    try {
      const response = await fetch(`${baseUrl}/education-categories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ education_category: newEducation }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to save education category");
      }

      await fetchEducationOptions();
      setFormFields((prev) => ({ ...prev, educationCategory: newEducation }));
      setIsDialogOpen(false);
      setNewEducation("");
      toast.success("Education category added successfully!");
    } catch (error) {
      console.error("Error saving education category:", error.message);
      toast.error(error.message || "An error occurred");
    }
  };

  const handleAddProfessional = async () => {
    try {
      const response = await fetch(`${baseUrl}/professional-categories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newProfessional }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to save professional category");
      }

      await fetchProfessionalOptions();
      setFormFields((prev) => ({ ...prev, professionalCategory: newProfessional }));
      setIsDialogOpen(false);
      setNewProfessional("");
      toast.success("Professional category added successfully!");
    } catch (error) {
      console.error("Error saving professional category:", error.message);
      toast.error(error.message || "An error occurred");
    }
  };

  const handleAddLicense = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!newLicense.trim()) {
      setErrors({ license: "License category is required" });
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/license-categories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newLicense }),
      });

      const data = await response.json();

      if (response.ok) {
        await fetchLicenseOptions();
        setFormFields((prev) => ({ ...prev, licenseCategory: newLicense }));
        setIsDialogOpen(false);
        setNewLicense("");
        setErrors({});
        toast.success("License category added successfully!");
      } else {
        throw new Error(data.error || "Failed to save license");
      }
    } catch (error) {
      console.error("Error saving license:", error);
      setErrors({ license: error.message });
      toast.error(error.message);
    }
  };

  const getFileUrl = (filePath) => {
    if (!filePath) return null;

    const filename = filePath.split("/").pop();
    if (filePath.includes("profile")) {
      return `${baseUrl}/profile/${filename}`;
    } else if (filePath.includes("attachments")) {
      return `${baseUrl}/file/${filename}`;
    }
    return filePath;
  };

  const handleProfileImageSelect = (e) => {
    const file = e.target.files[0];
    console.log("Selected profile image file:", file);
    if (file) {
      if (!file.type.startsWith("image/")) {
        alert("Please select an image file (JPEG, PNG, etc.)");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        alert("Profile image must be less than 2MB");
        return;
      }
      setFormFields((prev) => ({
        ...prev,
        profileImage: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const requiredFields = [
      { key: "candidateFirstName", label: "Candidate First Name" },
      { key: "candidateLastName", label: "Candidate Last Name" },
      { key: "dateOfBirth", label: "Date of Birth" },
      { key: "gender", label: "Gender" },
      { key: "officialEmail", label: "Official Email" },
      { key: "whatsappNo", label: "WhatsApp Number" },
      { key: "phoneNo", label: "Phone Number" },
      { key: "passportNumber", label: "Passport Number" },
      { key: "passportIssueDate", label: "Passport Issue Date" },
      { key: "passportExpiryDate", label: "Passport Expiry Date" },
      { key: "professionalCategory", label: "Professional Category" },
      { key: "educationCategory", label: "Education Category" },
      { key: "licenseCategory", label: "License Category" },
      { key: "totalProcessingFees", label: "Total Processing Fees" },
      { key: "firstInstallmentPaid", label: "First Installment Paid" },
      { key: "firstInstallmentDate", label: "First Installment Date" },
      { key: "balance", label: "Balance" },
      { key: "licenseProcessedBy", label: "License Processed By" },
      { key: "remarks", label: "Remarks" },
      { key: "referredBy", label: "Referred By" },
      { key: "status", label: "Status" },
    ];

    for (let i = 0; i < requiredFields.length; i++) {
      const { key, label } = requiredFields[i];
      if (!formFields[key] || formFields[key].toString().trim() === "") {
        toast.error(`${label} is required`, { autoClose: 3000 });
        setIsSubmitting(false);
        return;
      }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formFields.officialEmail && !emailRegex.test(formFields.officialEmail)) {
      toast.error("Invalid email format", { autoClose: 3000 });
      setIsSubmitting(false);
      return;
    }

    if (!nameRegex.test(formFields.candidateFirstName) && formFields.candidateFirstName !== "") {
      toast.error("First name should only contain letters", { autoClose: 3000 });
      setIsSubmitting(false);
      return;
    }

    if (!nameRegex.test(formFields.candidateLastName) && formFields.candidateLastName !== "") {
      toast.error("Last name should only contain letters", { autoClose: 3000 });
      setIsSubmitting(false);
      return;
    }

    const conditionalChecks = [
      { paid: "secondInstallmentPaid", date: "secondInstallmentDate", label: "Second Installment Date" },
      { paid: "thirdInstallmentPaid", date: "thirdInstallmentDate", label: "Third Installment Date" },
      { paid: "fourthInstallmentPaid", date: "fourthInstallmentDate", label: "Fourth Installment Date" },
    ];

    for (const { paid, date, label } of conditionalChecks) {
      if (formFields[paid] && parseFloat(formFields[paid]) > 0 && !formFields[date]) {
        toast.error(`${label} is required when amount is entered`, { autoClose: 3000 });
        setIsSubmitting(false);
        return;
      }
    }

    const total = parseFloat(formFields.totalProcessingFees) || 0;
    const first = parseFloat(formFields.firstInstallmentPaid) || 0;
    const second = parseFloat(formFields.secondInstallmentPaid) || 0;
    const third = parseFloat(formFields.thirdInstallmentPaid) || 0;
    const fourth = parseFloat(formFields.fourthInstallmentPaid) || 0;
    const paid = first + second + third + fourth;

    if (paid > total) {
      toast.warning(
        `Installment total (₹${paid.toLocaleString("en-IN")}) exceeds the total fees (₹${total.toLocaleString(
          "en-IN"
        )}) by ₹${(paid - total).toFixed(2)}. ` +
          `Please adjust the installment amounts or increase the total processing fees.`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setIsSubmitting(false);
      return;
    }

    try {
      const formData = new FormData();

      Object.entries(formFields).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") return;

        if (key === "profileImage" || key === "attachments") return;

        const dateFields = [
          "dateOfBirth",
          "passportIssueDate",
          "passportExpiryDate",
          "firstInstallmentDate",
          "secondInstallmentDate",
          "thirdInstallmentDate",
          "fourthInstallmentDate",
        ];

        if (dateFields.includes(key) && value) {
          // Keep the date as-is (already in YYYY-MM-DD format from input)
          formData.append(key, value);
        } else if (typeof value === "object") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value.toString());
        }
      });

      // Add ID for editing
      if (isEditing && formFields._id) {
        formData.append("_id", formFields._id);
      }

      if (formFields.profileImage && typeof formFields.profileImage !== "string") {
        formData.append("profileImage", formFields.profileImage);
      }

      if (formFields.attachments && formFields.attachments.length > 0) {
        const existingAttachments = [];
        const newFiles = [];

        formFields.attachments.forEach((item) => {
          if (typeof item === "string") {
            existingAttachments.push(item);
          } else {
            newFiles.push(item);
          }
        });

        newFiles.forEach((file) => {
          formData.append("attachments", file);
        });

        if (existingAttachments.length > 0) {
          formData.append("existingAttachments", JSON.stringify(existingAttachments));
        }
      }

      console.log("Form Data being sent:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const url =
        isEditing && formFields._id
          ? `${baseUrl}/candidate/${formFields._id}`
          : `${baseUrl}/candidate`;

      const method = isEditing && formFields._id ? "PUT" : "POST";

      console.log(`Sending ${method} request to:`, url);

      const response = await fetch(url, {
        method,
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Something went wrong");
      }

      // Try to parse as JSON
      const contentType = response.headers.get("content-type");
      let data;

      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        const text = await response.text();
        console.warn("Non-JSON response received:", text.substring(0, 200));
        data = { message: "Success" };
      }

      if (data.error) {
        throw new Error(data.error || data.message || "Something went wrong");
      }

      console.log("Success response:", data);
      toast.success(isEditing ? "Candidate updated successfully!" : "Form submitted successfully!");

      setTimeout(() => {
        navigate("/candidate-list");
      }, 1500);
    } catch (err) {
      console.error("Submission error:", err);
      const errorMsg =
        err.response?.data?.error || // backend message
        err.message || // fallback
        "Failed to submit form. Please try again.";

      toast.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openImagePopup = (file) => {
    setPopupImage(file);
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setShowImagePopup(false);
    setPopupImage(null);
  };

  const removeProfileImage = () => {
    setFormFields((prev) => ({
      ...prev,
      profileImage: null,
    }));
  };

  // Loading state for candidate data
  if (isLoadingCandidate) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
          <p className="mt-4 text-gray-600">Loading candidate data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-2 sm:px-6 lg:px-4">
      <div className="max-w-2xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-4 mt-10 px-6 py-4 bg-white rounded-xl shadow-sm border border-gray-100">
          {/* LEFT SIDE: Profile + Title */}
          <div className="flex items-center">
            {/* Profile icon */}
            <div className="mr-5">
              <div className="relative">
                <div
                  className="w-20 h-20 rounded-full border-2 border-gray-200 shadow-md overflow-hidden cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors"
                  onClick={() => document.getElementById("profileUpload").click()}
                >
                  {formFields.profileImage ? (
                    <img
                      src={
                        typeof formFields.profileImage === "string"
                          ? getFileUrl(formFields.profileImage)
                          : URL.createObjectURL(formFields.profileImage)
                      }
                      alt="Profile preview"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  )}
                </div>

                {/* Camera icon */}
                <div
                  className="absolute bottom-0 right-0 bg-green-500 rounded-full p-1.5 cursor-pointer shadow-md hover:bg-blue-600 transition-colors"
                  onClick={() => document.getElementById("profileUpload").click()}
                >
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
              </div>

              <input
                id="profileUpload"
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleProfileImageSelect}
              />
            </div>

            {/* Title */}
            <div>
              <h1 className="text-xl font-bold text-gray-800">
                {isEditing ? "Edit Candidate" : "Candidate Registration"}
              </h1>
              <p className="mt-1 text-sm text-gray-600 max-w-md">
                {isEditing
                  ? "Update the details of this candidate"
                  : "Fill in the details to complete your registration"}
              </p>
            </div>
          </div>

          {/* RIGHT SIDE: Application Status (Two‑level cascading dropdown) */}
          <div className="w-full md:w-64">
            <label className="block text-ls font-medium text-green-700 mb-2">Status</label>
            <div className="relative" ref={statusDropdownRef}>
              <button
                type="button"
                onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 bg-white text-left flex justify-between items-center"
              >
                <span className={!formFields.status ? "text-gray-500" : "text-gray-700"}>
                  {formFields.status || "Select Status"}
                </span>
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>

              {showStatusDropdown && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg">
                  <div className="flex">
                    {/* Left column – main headings */}
                    <div className="w-1/2 border-r border-gray-200">
                      {Object.keys(statusGroups).map((group) => (
                        <div
                          key={group}
                          className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                            selectedGroup === group ? "bg-blue-50 text-green-700" : ""
                          }`}
                          onClick={() => setSelectedGroup(group)}
                        >
                          {group}
                        </div>
                      ))}
                    </div>
                    {/* Right column – sub‑options for selected group */}
                    <div className="w-1/2">
                      {selectedGroup &&
                        statusGroups[selectedGroup]?.map((option) => (
                          <div
                            key={option}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => {
                              setFormFields((prev) => ({ ...prev, status: option }));
                              setShowStatusDropdown(false);
                            }}
                          >
                            {option}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          {/* Progress Steps */}
          <div className="flex border-b">
            <button
              onClick={() => setActiveSection("personal")}
              className={`flex-1 py-4 px-2 text-center font-medium ${
                activeSection === "personal"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Personal
            </button>
            <button
              onClick={() => setActiveSection("documents")}
              className={`flex-1 py-4 px-2 text-center font-medium ${
                activeSection === "documents"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Documents
            </button>
            <button
              onClick={() => setActiveSection("payment")}
              className={`flex-1 py-4 px-2 text-center font-medium ${
                activeSection === "payment"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Payment
            </button>
            <button
              onClick={() => setActiveSection("additional")}
              className={`flex-1 py-4 px-2 text-center font-medium ${
                activeSection === "additional"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Additional
            </button>
          </div>

          <div className="p-6 sm:p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Personal Information Section */}
              {activeSection === "personal" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <h3 className="sr-only">Personal Information</h3>
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-black-600 mb-1">First Name</label>
                    <input
                      type="text"
                      name="candidateFirstName"
                      value={formFields.candidateFirstName}
                      onChange={handleChange}
                      placeholder=" "
                      className={`peer w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                        errors.candidateFirstName ? "border-red-500" : "border-gray-200"
                      }`}
                    />
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-black-600 mb-1">Last Name</label>
                    <input
                      type="text"
                      name="candidateLastName"
                      value={formFields.candidateLastName}
                      onChange={handleChange}
                      placeholder=" "
                      className={`peer w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                        errors.candidateLastName ? "border-red-500" : "border-gray-200"
                      }`}
                    />
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-black-600 mb-1">Date of Birth *</label>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 peer ${
                        errors.dateOfBirth ? "border-red-500" : "border-gray-200"
                      }`}
                      value={formFields.dateOfBirth}
                      onChange={handleChange}
                      placeholder=" "
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-black-600 mb-1">Email *</label>
                    <input
                      type="email"
                      className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                        errors.officialEmail ? "border-red-500" : "border-gray-200"
                      }`}
                      value={formFields.officialEmail}
                      onChange={handleChange}
                      name="officialEmail"
                      placeholder="officialEmail"
                    />
                    {errors.officialEmail && (
                      <p className="mt-1 text-sm text-red-600">{errors.officialEmail}</p>
                    )}
                  </div>

                  <div className="md:col-span-1">
                    <div className="md:col-span-1">
                      <PhoneInput
                        country={"in"}
                        value={formFields.phoneNo}
                        specialLabel="Mobile Number"
                        onChange={(value) => {
                          const cleanedValue = value ? value.replace(/-/g, "") : "";
                          handlePhoneChange(cleanedValue, "phoneNo");
                        }}
                        inputClass={`!w-full !h-12 !px-12 !bg-white !rounded-lg !border-2 !focus:outline-none !outline-none !ring-0 !focus:ring-0 ${
                          errors.phoneNo ? "!border-red-500" : "!border-green-200 focus:!border-green-500"
                        }`}
                        containerClass="!w-full"
                        placeholder="Mobile Number *"
                      />
                      {errors.phoneNo && <p className="mt-1 text-sm text-red-600">{errors.phoneNo}</p>}
                    </div>
                  </div>

                  <div className="md:col-span-1">
                    <PhoneInput
                      country={"in"}
                      value={formFields.whatsappNo}
                      specialLabel="Whatsapp Number *"
                      onChange={(value) => handlePhoneChange(value, "whatsappNo")}
                      inputClass={`!w-full !h-12 !px-12 !bg-white !rounded-lg !border-2 !focus:outline-none !outline-none !ring-0 !focus:ring-0 ${
                        errors.phoneNo ? "!border-red-500" : "!border-green-200 focus:!border-green-500"
                      }`}
                      containerClass="!w-full"
                      placeholder="WhatsApp Number *"
                    />
                    {errors.whatsappNo && <p className="mt-1 text-sm text-red-600">{errors.whatsappNo}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-black-600 mb-1">Gender *</label>
                    <select
                      className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                        errors.gender ? "border-red-500" : "border-gray-200"
                      }`}
                      value={formFields.gender}
                      onChange={handleChange}
                      name="gender"
                    >
                      <option value="" disabled>
                        Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="md:col-span-2 flex justify-between">
                    <button
                      type="button"
                      className="px-6 py-2 text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50"
                      disabled
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveSection("documents")}
                      className="px-6 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

              {/* Documents Section */}
              {activeSection === "documents" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <h3 className="sr-only">Document Information</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-black-600 mb-1">Passport Number</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                      value={formFields.passportNumber}
                      onChange={handleChange}
                      name="passportNumber"
                    />
                  </div>

                  <div>
                    <div className="relative">
                      <label className="block text-sm font-medium text-black-600 mb-1">Passport Issue Date</label>
                      <input
                        type="date"
                        id="passportIssueDate"
                        name="passportIssueDate"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 peer ${
                          errors.passportIssueDate ? "border-red-500" : "border-gray-200"
                        }`}
                        value={formFields.passportIssueDate}
                        onChange={handleChange}
                        placeholder=" "
                      />
                    </div>
                  </div>

                  <div>
                    <div className="relative">
                      <label className="block text-sm font-medium text-black-600 mb-1">Passport Expiry Date</label>
                      <input
                        type="date"
                        id="passportExpiryDate"
                        name="passportExpiryDate"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 peer ${
                          errors.passportExpiryDate ? "border-red-500" : "border-gray-200"
                        }`}
                        value={formFields.passportExpiryDate}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-black-600 mb-1">Professional Category *</label>
                    <select
                      className={`w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500 max-h-44 overflow-y-auto ${
                        !formFields.professionalCategory ? "text-gray-400" : "text-gray-700"
                      }`}
                      value={formFields.professionalCategory}
                      onChange={handleChange}
                      name="professionalCategory"
                      style={{
                        maxHeight: "130px",
                        overflowY: "auto",
                      }}
                    >
                      <option value="" disabled className="text-gray-400">
                        Select Professional
                      </option>
                      {professionalOptions.map((option) => (
                        <option key={option} value={option} className="text-gray-700">
                          {option}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={() => {
                        setCurrentDropdown("professional");
                        setIsDialogOpen(true);
                      }}
                      className="absolute right-5 top-1/2 transform-translate-y-1/2 text-green-600 hover:text-green-800"
                    >
                      + Add
                    </button>
                  </div>

                  <div>
                    <div className="relative">
                      <label className="block text-sm font-medium text-black-600 mb-1">Education Category *</label>
                      <select
                        className={`w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500 ${
                          !formFields.educationCategory ? "text-gray-400" : "text-gray-700"
                        }`}
                        value={formFields.educationCategory}
                        onChange={handleChange}
                        name="educationCategory"
                      >
                        <option value="" disabled className="text-gray-400">
                          Select Education
                        </option>
                        {educationOptions.map((option, index) => (
                          <option key={index} value={option} className="text-gray-700">
                            {option}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => {
                          setCurrentDropdown("education");
                          setIsDialogOpen(true);
                        }}
                        className="absolute right-5 top-1/2 transform-translate-y-1/2 text-green-600 hover:text-green-800"
                      >
                        + Add
                      </button>
                    </div>
                  </div>

                  {isDialogOpen && currentDropdown === "professional" && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-lg font-medium mb-4">Add Professional Category</h3>
                        <div className="mb-4">
                          <input
                            type="text"
                            className={`w-full px-4 py-2 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                              errors.professional ? "border-red-500" : "border-gray-200"
                            }`}
                            value={newProfessional}
                            onChange={(e) => setNewProfessional(e.target.value)}
                            placeholder="Enter professional category"
                          />
                          {errors.professional && (
                            <p className="text-red-500 text-sm mt-1">{errors.professional}</p>
                          )}
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDialogOpen(false);
                              setNewProfessional("");
                              setErrors({});
                            }}
                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={handleAddProfessional}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {isDialogOpen && currentDropdown === "education" && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-lg font-medium mb-4">Add Education Category</h3>
                        <div className="mb-4">
                          <input
                            type="text"
                            className={`w-full px-4 py-2 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                              errors.education ? "border-red-500" : "border-gray-200"
                            }`}
                            value={newEducation}
                            onChange={(e) => setNewEducation(e.target.value)}
                            placeholder="Enter education category"
                          />
                          {errors.education && (
                            <p className="text-red-500 text-sm mt-1">{errors.education}</p>
                          )}
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDialogOpen(false);
                              setNewEducation("");
                              setErrors({});
                            }}
                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={handleAddEducation}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    <div className="relative">
                      <label className="block text-sm font-medium text-black-600 mb-1">License Category</label>
                      <select
                        className={`w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500 ${
                          !formFields.licenseCategory ? "text-gray-400" : "text-gray-700"
                        }`}
                        value={formFields.licenseCategory || ""}
                        onChange={(e) => {
                          handleChange(e);
                          if (!e.target.value) {
                            e.target.classList.add("text-gray-400");
                            e.target.classList.remove("text-gray-700");
                          } else {
                            e.target.classList.remove("text-gray-400");
                            e.target.classList.add("text-gray-700");
                          }
                        }}
                        name="licenseCategory"
                      >
                        <option value="" disabled className="text-gray-400">
                          Select License
                        </option>
                        {licenseOptions.map((option, index) => (
                          <option key={index} value={option} className="text-gray-700">
                            {option}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => {
                          setCurrentDropdown("license");
                          setIsDialogOpen(true);
                        }}
                        className="absolute right-5 top-1/2 transform-translate-y-1/2 text-green-600 hover:text-green-800"
                      >
                        + Add
                      </button>
                    </div>
                  </div>

                  {isDialogOpen && currentDropdown === "license" && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-lg font-medium mb-4">Add License Category</h3>
                        <div className="mb-4">
                          <input
                            type="text"
                            className={`w-full px-4 py-2 rounded-lg border-2 focus:outline-none focus:ring-0 focus:border-green-500 ${
                              errors.license ? "border-red-500" : "border-gray-200"
                            }`}
                            value={newLicense}
                            onChange={(e) => setNewLicense(e.target.value)}
                            placeholder="Enter license category"
                          />
                          {errors.license && (
                            <p className="text-red-500 text-sm mt-1">{errors.license}</p>
                          )}
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDialogOpen(false);
                              setNewLicense("");
                              setErrors({});
                            }}
                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={handleAddLicense}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="md:col-span-2 flex justify-between">
                    <button
                      type="button"
                      onClick={() => setActiveSection("personal")}
                      className="px-6 py-2 text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50"
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveSection("payment")}
                      className="px-6 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}

              {/* Payment Section */}
              {activeSection === "payment" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-black mb-1">Total Fees (₹)</label>
                    <input
                      type="number"
                      className="w-full px-4 py-3 rounded-lg border-2 border-green-100 focus:outline-none focus:ring-0 focus:border-green-300"
                      value={formFields.totalProcessingFees}
                      onChange={handleChange}
                      name="totalProcessingFees"
                      min="0"
                      step="0.01"
                      onKeyDown={(e) =>
                        (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-black-600 mb-1">Balance (₹)</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 rounded-lg border-2 border-green-100 bg-green-50"
                      value={formFields.balance}
                      readOnly
                      disabled
                    />
                  </div>

                  {/* 1st Installment */}
                  <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-blue-50 rounded-lg">
                    <div className="font-medium text-blue-800 mb-2 md:col-span-2">1st Installment</div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Amount (₹)</label>
                      <input
                        type="number"
                        className="w-full px-4 py-3 rounded-lg border-2 border-green-100 focus:outline-none focus:ring-0 focus:border-green-300"
                        value={formFields.firstInstallmentPaid}
                        onChange={handleChange}
                        name="firstInstallmentPaid"
                        min="0"
                        step="0.01"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) =>
                          (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Payment Date</label>
                      <input
                        type="date"
                        className="w-full px-4 py-3 rounded-lg border-2 border-green-100 focus:outline-none focus:ring-0 focus:border-green-300"
                        value={formFields.firstInstallmentDate || ""}
                        onChange={handleChange}
                        name="firstInstallmentDate"
                        onKeyDown={(e) => {
                          if (!["Tab", "Escape", "Enter"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* 2nd Installment */}
                  <div
                    className={`md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 p-4 rounded-lg transition-opacity ${
                      !formFields.firstInstallmentPaid ? "opacity-50 bg-gray-100" : "bg-yellow-50"
                    }`}
                  >
                    <div className="font-medium text-yellow-800 mb-2 md:col-span-2">2nd Installment</div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Amount (₹)</label>
                      <input
                        type="number"
                        className={`w-full px-4 py-3 rounded-lg border-2 ${
                          formFields.firstInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.secondInstallmentPaid}
                        onChange={handleChange}
                        name="secondInstallmentPaid"
                        min="0"
                        step="0.01"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) =>
                          (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Payment Date</label>
                      <input
                        type="date"
                        className={`w-full px-4 py-3 rounded-lg border-2 ${
                          formFields.firstInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.secondInstallmentDate || ""}
                        onChange={handleChange}
                        name="secondInstallmentDate"
                        onKeyDown={(e) => {
                          if (!["Tab", "Escape", "Enter"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* 3rd Installment */}
                  <div
                    className={`md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 p-4 rounded-lg transition-opacity ${
                      !formFields.secondInstallmentPaid ? "opacity-50 bg-gray-100" : "bg-green-50"
                    }`}
                  >
                    <div className="font-medium text-green-800 mb-2 md:col-span-2">3rd Installment</div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Amount (₹)</label>
                      <input
                        type="number"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 ${
                          formFields.secondInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.thirdInstallmentPaid}
                        onChange={handleChange}
                        name="thirdInstallmentPaid"
                        min="0"
                        step="0.01"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) =>
                          (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Payment Date</label>
                      <input
                        type="date"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 ${
                          formFields.secondInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.thirdInstallmentDate || ""}
                        onChange={handleChange}
                        name="thirdInstallmentDate"
                        onKeyDown={(e) => {
                          if (!["Tab", "Escape", "Enter"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* 4th Installment */}
                  <div
                    className={`md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 p-4 rounded-lg transition-opacity ${
                      !formFields.thirdInstallmentPaid ? "opacity-50 bg-gray-100" : "bg-green-50"
                    }`}
                  >
                    <div className="font-medium text-blue-800 mb-2 md:col-span-2">4th Installment</div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Amount (₹)</label>
                      <input
                        type="number"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 ${
                          formFields.thirdInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.fourthInstallmentPaid}
                        onChange={handleChange}
                        name="fourthInstallmentPaid"
                        min="0"
                        step="0.01"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) =>
                          (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black-600 mb-1">Payment Date</label>
                      <input
                        type="date"
                        className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-0 ${
                          formFields.thirdInstallmentPaid
                            ? "border-green-100 focus:border-green-300"
                            : "border-gray-200"
                        }`}
                        value={formFields.fourthInstallmentDate || ""}
                        onChange={handleChange}
                        name="fourthInstallmentDate"
                        onKeyDown={(e) => {
                          if (!["Tab", "Escape", "Enter"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="md:col-span-2 flex justify-between pt-4">
                    <button
                      type="button"
                      onClick={() => setActiveSection("documents")}
                      className="px-6 py-2 text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                      disabled={isSubmitting}
                    >
                      Back
                    </button>
                    <div className="flex gap-3">
                      {isEditing && (
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className={`px-6 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors ${
                            isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                          }`}
                        >
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => setActiveSection("additional")}
                        disabled={isSubmitting}
                        className={`px-6 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors ${
                          isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Additional Information Section */}
              {activeSection === "additional" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <h3 className="sr-only">Additional Information</h3>
                  </div>

                  <div className="relative w-full">
                    <label className="block text-sm font-medium text-gray-600 mb-1">Processed By</label>
                    <select
                      name="licenseProcessedBy"
                      value={formFields.licenseProcessedBy || ""}
                      onChange={(e) => handleChange(e)}
                      className={`peer w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500 appearance-none ${
                        !formFields.licenseProcessedBy ? "text-gray-400" : "text-gray-700"
                      }`}
                    >
                      <option value="" disabled className="text-gray-400">
                        Select Processed By
                      </option>
                      {admins &&
                        admins.map((admin) => (
                          <option key={admin.id} value={admin.name} className="text-gray-700">
                            {admin.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Candidate Registration Number
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                      value={formFields.registrationNumber}
                      onChange={handleChange}
                      name="registrationNumber"
                      placeholder="Registration Number"
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Referred By</label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                      value={formFields.referredBy}
                      onChange={handleChange}
                      name="referredBy"
                      placeholder="Referred By"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <textarea
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-green-500"
                      value={formFields.remarks}
                      onChange={handleChange}
                      name="remarks"
                      rows="3"
                      placeholder="Remarks..."
                    ></textarea>
                  </div>

                  <div className="md:col-span-2">
                    <div className="flex flex-col items-center justify-center w-full">
                      {formFields.attachments && formFields.attachments.length > 0 && (
                        <div className="w-full mb-4">
                          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
                            {formFields.attachments.map((file, index) => {
                              const isFileObject = file instanceof File;
                              const fileUrl = isFileObject
                                ? URL.createObjectURL(file)
                                : getFileUrl(file);

                              const fileName = isFileObject ? file.name : file.split("/").pop();
                              const isPDF =
                                file.type === "application/pdf" ||
                                fileName.toLowerCase().endsWith(".pdf");
                              return (
                                <div key={index} className="relative group">
                                  <div
                                    className="h-24 w-full rounded-md overflow-hidden border border-gray-200 bg-gray-100 flex items-center justify-center cursor-pointer"
                                    onClick={() => {
                                      if (isPDF) {
                                        window.open(fileUrl, "_blank");
                                      } else {
                                        openImagePopup(file);
                                      }
                                    }}
                                  >
                                    {isPDF ? (
                                      <div className="flex flex-col items-center justify-center text-gray-600">
                                        <svg
                                          className="w-10 h-10 mb-1 text-red-500"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M6 2a2 2 0 0 0-2 2v16a2..." />
                                        </svg>
                                        <span className="text-xs font-medium">PDF File</span>
                                      </div>
                                    ) : (
                                      <img
                                        src={fileUrl}
                                        alt={`Preview ${index + 1}`}
                                        className="h-full w-full object-cover"
                                      />
                                    )}
                                  </div>

                                  <button
                                    type="button"
                                    onClick={() => removeAttachment(index)}
                                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                                    aria-label="Remove file"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                      ></path>
                                    </svg>
                                  </button>

                                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 truncate">
                                    {fileName}
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div className="text-sm text-gray-500 mt-2">
                            {formFields.attachments.length} of 10 files selected
                          </div>
                        </div>
                      )}

                      {(!formFields.attachments || formFields.attachments.length < 10) && (
                        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500">
                              <span className="font-semibold">Click to upload</span> or drag and drop
                            </p>
                            <p className="text-xs text-gray-500">
                              {formFields.attachments && formFields.attachments.length > 0
                                ? `Add more files (${10 - formFields.attachments.length} remaining)`
                                : "PNG, JPG, JPEG up to 10MB"}
                            </p>
                          </div>
                          <input
                            type="file"
                            className="hidden"
                            multiple
                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                            onChange={handleFileSelect}
                            disabled={formFields.attachments && formFields.attachments.length >= 10}
                          />
                        </label>
                      )}
                    </div>
                  </div>

                  {showImagePopup && (
                    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                      <div className="bg-white rounded-lg max-w-4xl w-full max-h-screen overflow-hidden flex flex-col">
                        <div className="flex justify-between items-center p-4 border-b">
                          <h3 className="text-lg font-semibold">
                            {popupImage instanceof File
                              ? popupImage.name
                              : popupImage?.split("/").pop()}
                          </h3>
                          <button
                            onClick={closeImagePopup}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <svg
                              className="w-6 h-6"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        <div className="flex-1 overflow-auto flex items-center justify-center p-4">
                          <img
                            src={
                              popupImage
                                ? popupImage instanceof File
                                  ? URL.createObjectURL(popupImage)
                                  : getFileUrl(popupImage)
                                : ""
                            }
                            alt="Preview"
                            className="max-w-full max-h-full object-contain"
                          />
                        </div>
                        <div className="p-4 border-t flex justify-end">
                          <button
                            onClick={closeImagePopup}
                            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="md:col-span-2 flex justify-between pt-4">
                    <button
                      type="button"
                      onClick={() => setActiveSection("payment")}
                      className="px-6 py-2 text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 cursor-pointer"
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      className={`px-6 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 ${
                        isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                      }`}
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? "Saving..."
                        : isEditing
                          ? "Save Changes"
                          : "Complete Registration"}
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default CandidateRegistrationForm;
